module.exports = class LanguageService {

  static $inject = [
    '$ngRedux',
    '$state',
    '$translate',
    'PatientsService',
    'PatientAppContextService',
    'SessionService',
  ];

  isWaitingForSwitchCompletion = false;

  constructor(
    $ngRedux,
    $state,
    $translate,
    PatientsService,
    PatientAppContextService,
    SessionService,
  ) {
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.$translate = $translate;
    this.PatientsService = PatientsService;
    this.PatientAppContextService = PatientAppContextService;
    this.SessionService = SessionService;

    // I didn't find any way to override just a few attributes, we have to override them all :(
    moment.locale('fr-ca', {
      months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
      monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
      weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
      weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
      longDateFormat: {
        LT: 'HH [h] mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'Do MMMM YYYY',
        LLL: 'D MMMM YYYY LT',
        LLLL: 'dddd D MMMM YYYY LT',
      },
      calendar: {
        sameDay: '[Aujourd\'hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L',
      },
      relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'une année',
        yy: '%d années',
      },
      ordinalParse: /\d{1,2}(er)/,
      ordinal(number) {
        return number + (number === 1 ? 'er' : '');
      },
      week: {
        dow: 1,
        doy: 4,
      },
    });
  }

  switchLanguage() {
    if (this.isWaitingForSwitchCompletion) {
      return;
    }

    this.isWaitingForSwitchCompletion = true;

    const newLocale = this.$translate.use() === 'fr_CA' ? 'en' : 'fr_CA';

    const group = this.$ngRedux.getState().group;

    if (this.PatientAppContextService.context.authenticatedPatient) {
      this.PatientsService.changeLocale(this.PatientAppContextService.context.authenticatedPatient.id, group.id, newLocale, () => {
        this.SessionService.load().then(() => {
          this.$state.reload();
        });
      });
    } else {
      this.$state.go(this.$state.current.name, { locale: newLocale }, { reload: true });
    }
  }

  useLanguage(language) {
    this.$translate.use(language);
    moment.locale(language.toLowerCase().replace(/_/g, '-'));
  }
};



// WEBPACK FOOTER //
// ./main/services/language-service.js